import React from "react";
import defaultImage from "../../../../../assets/brandLogos/Default_Brand.svg";
import { SocialMedialogo } from "../../../../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import { Progress, Space, Tooltip } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
  callNotification,
  getBrands,
  getCustomizedDate,
  getPaneIndex,
  getWindowLocationPath,
  useQuery,
} from "../../../../../redux/constants";
import {
  setDeepDiveInfoLoader,
  setIsDetailedInsightVisible,
  setTabClick,
} from "../../../../../redux/actions/DeepDive";
import {
  setDeepDiveInfluencersObject,
  setDeepDiveMentionsObject,
  setDeepDiveObject,
  set_WM_DeepDive,
} from "../../../../../redux/actions/WidgetMaker/WidgetMaker";
import { getDeepDive } from "../../../../../redux/actions/WidgetMaker/WidgetAPI";
import moment from "moment";
import { getAllWidgetScreenFilters } from "../../../../../redux/constants/commandCenterConstants";
import { setScreenIsDeepDive } from "../../../../../redux/actions/commandCenter/screens/screen";

const CircularKpi = ({ kpiData, widget_index, section_index }) => {
  let query = useQuery();
  const dispatch = useDispatch();
  const screen = useSelector((state) => state?.Screens?.screen);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);
  const global_dashboard_duration = useSelector(
    (state) => state.AuthParams.global_dashboard_duration
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const shareTemplateData = useSelector(
    (state) => state.ApiCall.shareTemplateData
  );
  const shareableLinkDeepDiveStatus = useSelector(
    (state) => state.ApiCall.shareableLinkDeepDiveStatus
  );
  const sharedDuration = useSelector((state) => state.Share.sharedDuration);
  const shareCategory = useSelector((state) => state.ApiCall.shareCategory);
  const authParams = useSelector((state) => state.Authentication.authParams);
  const shareBrands = useSelector((state) => state.ApiCall.shareBrands);

  const brandlogicalgroup = useSelector(
    (state) => state.ApiCall.brandlogicalgroup?.data?.result
  );
  const global_dashboard_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_brands
  );
  const global_dashboard_single_brands = useSelector(
    (state) => state.AuthParams.global_dashboard_single_brands
  );
  const brands = useSelector(
    (state) => state.ApiCall.brands?.data?.result?.brands
  );
  const graphConditionConfig = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const widgetGraphConfigState = useSelector(
    (state) => state?.GraphConfig?.widgetGraphConfig
  );
  const workspace_privileges = useSelector(
    (state) => state.ApiCall.workspace_privileges
  );
  const share_workspace_privileges = useSelector(
    (state) => state.ApiCall.share_workspace_privileges
  );

  let index = getPaneIndex(panes, activeKey);
  let shareSections = shareTemplateData?.section
    ? shareTemplateData?.section?.[0]
    : shareTemplateData?.sections?.[section_index];
  let widget_metadata = shareBrands
    ? shareSections?.widgets?.[widget_index]
    : section_index >= 0 && screen?.sections
    ? screen?.sections?.[section_index]?.widgets?.[widget_index]
    : screen?.section?.[0]?.widgets?.[widget_index];

  let deepdiveTypes =
    widget_metadata?.chart?.chart_type === "kpi"
      ? widget_metadata?.x_axis?.attribute?.toLowerCase()
      : widget_metadata?.chart?.chart_settings?.cards_settings
          ?.filter((e) => e?.x_axis)
          ?.map((el) => el?.x_axis?.attribute?.toLowerCase());

  // console.log("kpiData", kpiData);

  const handleKpiDeepdive = (e, data) => {
    if (data?.text !== "Others" && data?.value !== null && data?.value > 0) {
      let pathName = getWindowLocationPath()?.toLowerCase();
      // let widget_ids = ["info-bar", "1.1", "1.2"];
      let widget_ids =
        workspace_privileges?.environment === 2 ||
        share_workspace_privileges?.environment === 2
          ? ["info-bar", "2.1", "2.2", "2.3", "2.4"]
          : ["info-bar", "1.1", "1.2"];

      let shareSections = shareTemplateData?.section
        ? shareTemplateData?.section?.[0]
        : shareTemplateData?.sections?.[section_index];

      let widget_metadata = screen?.widgets?.[widget_index];

      let section_metadata = shareBrands
        ? shareSections
        : section_index >= 0
        ? screen?.sections?.[section_index]
        : screen?.section?.[0];
      let Section_is_locked = section_metadata?.is_locked;
      let widgets_is_locked = widget_metadata?.is_locked;
      let twoMonthsDuration = getCustomizedDate(6, "Days");
      let defaultDuration = {
        from:
          moment(twoMonthsDuration?.date[0]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.startTime,
        to:
          moment(twoMonthsDuration?.date[1]).format("YYYY/MM/DD") +
          " " +
          twoMonthsDuration?.time?.endTime,
      };

      let global_duration = shareBrands
        ? sharedDuration?.from
          ? {
              from: sharedDuration?.from,
              to: sharedDuration?.to,
            }
          : null
        : screen?.duration;

      let global_brands = shareBrands ? shareBrands : screen?.brands;
      let brandIds = shareBrands
        ? widget_metadata?.brand_ids
        : section_index >= 0
        ? screen?.sections?.[section_index]?.widgets?.[widget_index]?.brand_ids
        : screen?.section
        ? screen?.section?.[0]?.widgets?.[widget_index]?.brand_ids
        : screen?.widgets?.[widget_index]?.brand_ids;

      let sectionDateFilter = shareTemplateData?.sections
        ? {
            from: shareTemplateData?.sections[section_index]?.start_date
              ? shareTemplateData?.sections[section_index]?.start_date
              : null,
            to: shareTemplateData?.sections[section_index]?.end_date
              ? shareTemplateData?.sections[section_index]?.end_date
              : null,
          }
        : null;

      let widgetFilterDate = {
        from: widget_metadata?.start_date ? widget_metadata?.start_date : null,
        to: widget_metadata?.end_date ? widget_metadata?.end_date : null,
      };

      let combinedFilters = [];
      if (!widget_metadata?.is_locked) {
        if (widgetFilterDate?.from)
          combinedFilters.push({
            attribute: "CreatedDate"?.toLowerCase(),
            type: "datetime",
            columns: widgetFilterDate,
          });

        if (sectionDateFilter?.from && !section_metadata?.is_locked) {
          combinedFilters.push({
            attribute: "CreatedDate"?.toLowerCase(),
            type: "datetime",
            columns: sectionDateFilter,
          });
        }
        if (section_metadata?.brand_ids && !section_metadata?.is_locked) {
          let brands = getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          );

          combinedFilters.push(brands);
        }
        if (widget_metadata?.brand_ids) {
          let brands = getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          );

          combinedFilters.push(brands);
        }
      }

      if (widget_metadata?.filters)
        combinedFilters = [...widget_metadata?.filters, ...combinedFilters];
      if (section_metadata?.filters)
        combinedFilters = [...section_metadata?.filters, ...combinedFilters];
      let filterData = combinedFilters?.filter((d) => d);
      let hidden_filter = shareTemplateData?.hidden_filter
        ? [shareTemplateData?.hidden_filter]
        : [];
      let quick_filter = shareTemplateData?.quick_filter
        ? [shareTemplateData?.quick_filter]
        : [];

      let filter = getAllWidgetScreenFilters(
        screen,
        section_index,
        widget_index,
        brands,
        brandlogicalgroup,
        widget_metadata
      );

      let widget_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            widget_metadata?.brand_ids,
            shareBrands?.brand_list,
            widget_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            widget_metadata?.brand_ids,
            brands,
            widget_metadata?.brand_groups
          );
      let section_brands = shareBrands
        ? getBrands(
            shareBrands?.brand_groups,
            section_metadata?.brand_ids,
            shareBrands?.brand_list,
            section_metadata?.brand_groups
          )
        : getBrands(
            brandlogicalgroup,
            section_metadata?.brand_ids,
            brands,
            section_metadata?.brand_groups
          );
      let defaultBrands = shareBrands ? shareBrands : null;

      // This case is applied when we select competition brand and applied competition filter(Owned/Competition)
      // calculating brand in case of section comprtiotion brand type exists

      let sectionComprtitorBrandType =
        section_metadata?.comp_brand_type === false ||
        section_metadata?.comp_brand_type === true
          ? section_metadata?.comp_brand_type
          : null;
      let sectionComprtitorBrandTypeExists =
        sectionComprtitorBrandType === false ||
        sectionComprtitorBrandType === true;
      let globalBrandChangeInShare = false;
      let updatedComBrandList = [];
      // if (
      //   !(Section_is_locked && section_brands?.columns?.length) &&
      //   sectionComprtitorBrandTypeExists
      // ) {
      if (shareBrands) {
        let comBrand = defaultBrands?.brands?.columns?.[0]?.competitor
          ? defaultBrands?.brands?.columns?.[0]
          : defaultBrands?.brands?.[0]?.competitor
          ? defaultBrands?.brands?.[0]
          : defaultBrands?.brands?.competitor
          ? defaultBrands?.brands
          : null;
        let comBrandExists = comBrand?.competitor
          ? true
          : defaultBrands
          ? defaultBrands?.selected_brand_ids?.length &&
            defaultBrands?.selected_comp_brand_ids?.length > 0
          : null;
        if (comBrandExists) {
          if (comBrand) {
            if (sectionComprtitorBrandType === false) {
              updatedComBrandList.push({
                brand_id: comBrand?.name,
                brand_name: comBrand?.brand_name,
                brand_friendly_name: comBrand?.brand_friendly_name,
              });
            } else {
              comBrand?.competitorList?.forEach((competitorBrand) => {
                updatedComBrandList.push(competitorBrand);
              });
            }
            globalBrandChangeInShare = true;
          } else {
            if (sectionComprtitorBrandType === false) {
              let parentB = defaultBrands?.selected_brand_ids?.[0];
              updatedComBrandList.push({
                brand_id: parentB?.brand_id,
                brand_name: parentB?.brand_name,
                brand_friendly_name: parentB?.brand_friendly_name,
              });
            } else {
              defaultBrands?.selected_comp_brand_ids?.forEach(
                (competitorBrand) => {
                  updatedComBrandList.push(competitorBrand);
                }
              );
            }
          }
        } else {
          sectionComprtitorBrandTypeExists = false;
        }
      } else {
        let comBrand = global_brands?.columns?.[0]?.competitor
          ? global_brands?.columns?.[0]
          : global_brands?.[0]?.competitor
          ? global_brands?.[0]
          : global_brands?.competitor
          ? global_brands
          : null;
        if (comBrand?.competitor) {
          if (sectionComprtitorBrandType === false) {
            updatedComBrandList.push({
              brand_id: comBrand?.name,
              brand_name: comBrand?.brand_name,
              brand_friendly_name: comBrand?.brand_friendly_name,
            });
          } else {
            comBrand?.competitorList?.forEach((competitorBrand) => {
              updatedComBrandList.push(competitorBrand);
            });
          }
        } else {
          sectionComprtitorBrandTypeExists = false;
        }
      }
      // }
      // here calculating the public_engagement_only for the deepdive
      let public_engagement_only =
        pathName === "CommandCenter"?.toLowerCase()
          ? false // for now static false sending for command center
          : shareBrands
          ? shareTemplateData?.template_type === "competition"
            ? shareTemplateData?.public_engagement_only || false
            : false
          : panes?.[index]?.template_type === "competition"
          ? panes?.[index]?.public_engagement_only || false
          : false;
      let graphObject = {
        start_date: widgets_is_locked
          ? widget_metadata?.start_date
            ? widget_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : Section_is_locked
          ? section_metadata.start_date
            ? section_metadata?.start_date
            : global_duration?.from
            ? global_duration?.from
            : defaultDuration?.from
          : global_duration?.from
          ? global_duration?.from
          : defaultDuration?.from,
        end_date: widgets_is_locked
          ? widget_metadata?.end_date
            ? widget_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : Section_is_locked
          ? section_metadata?.end_date
            ? section_metadata?.end_date
            : global_duration?.to
            ? global_duration?.to
            : defaultDuration?.to
          : global_duration?.to
          ? global_duration?.to
          : defaultDuration?.to,
        brands: shareBrands
          ? widget_metadata?.is_locked
            ? widget_brands?.columns
              ? widget_brands?.columns
              : section_metadata?.is_locked
              ? section_brands?.columns
                ? section_brands?.columns
                : widget_metadata?.duplicate_for_brands
                ? widget_metadata?.com_brand_ids
                : sectionComprtitorBrandTypeExists
                ? updatedComBrandList
                : defaultBrands
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : section_metadata?.is_locked
            ? section_brands?.columns
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : defaultBrands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : defaultBrands
          : widgets_is_locked
          ? widget_metadata?.brand_ids || widget_metadata?.brand_groups
            ? widget_brands?.columns
            : Section_is_locked
            ? section_metadata?.brand_ids || section_metadata?.brand_groups
              ? section_brands?.columns
              : widget_metadata?.duplicate_for_brands
              ? widget_metadata?.com_brand_ids
              : sectionComprtitorBrandTypeExists
              ? updatedComBrandList
              : global_brands
              ? global_brands
              : brandlogicalgroup?.length > 0
              ? brandlogicalgroup
              : brands
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : Section_is_locked
          ? section_metadata?.brand_ids || section_metadata?.brand_groups
            ? section_brands?.columns
            : widget_metadata?.duplicate_for_brands
            ? widget_metadata?.com_brand_ids
            : sectionComprtitorBrandTypeExists
            ? updatedComBrandList
            : global_brands
            ? global_brands
            : brandlogicalgroup?.length > 0
            ? brandlogicalgroup
            : brands
          : widget_metadata?.duplicate_for_brands
          ? widget_metadata?.com_brand_ids
          : sectionComprtitorBrandTypeExists
          ? updatedComBrandList
          : global_brands
          ? global_brands
          : brandlogicalgroup?.length > 0
          ? brandlogicalgroup
          : brands,
        // isBrandModified:
        //   !shareBrands &&
        //   (widgets_is_locked || Section_is_locked) &&
        //   (section_metadata?.brand_ids ||
        //     section_metadata?.brand_groups ||
        //     widget_metadata?.brand_ids ||
        //     widget_metadata?.brand_groups)
        //     ? true
        //     : global_brands
        //     ? true
        //     : false,
        deepdive_on: {
          x_axis: {
            attribute: data?.attribute?.toLowerCase(),
            value: data?.text?.includes("|$|")
              ? data?.text?.split("|$|")?.[1]?.trim()
              : data?.text?.includes("|G|")
              ? data?.text?.split("|G|")?.[1]?.trim()
              : data?.text?.includes("|C|")
              ? data?.text?.split("|C|")?.[1]?.trim()
              : data?.text,
            trace_name: data?.trace_name
              ? data?.trace_name
              : allAttributes[data?.attribute?.toLowerCase()],
          },
          y_series: data?.y_series
            ? {
                ...data?.y_series,
                value: data?.value,
                trace_name: data?.y_series?.trace_name
                  ? data?.y_series?.trace_name
                  : data?.y_series?.attribute
                  ? allAttributes[data?.y_series?.attribute?.toLowerCase()]
                  : "",
              }
            : null,
        },
        filters: filter ? filter : null,
        paneIndex: index,
        panes: panes,
        screen: pathName === "CommandCenter"?.toLowerCase() ? screen : null,
        shareBrands: shareBrands,
        shareTemplateData: {
          ...shareTemplateData,
          isDeepDive: true,
          deep_dive: {
            infoBar: null,
            mentions: null,
            wordcloud: [],
            category: [],
            top_users: [],
            influencers: [],
            source_of_post: [],
            locations: [],
          },
        },
        tabName:
          workspace_privileges?.environment === 2 ||
          share_workspace_privileges?.environment === 2
            ? "Word Cloud"
            : "Mentions",
        shareCategory: shareCategory,
        filter_by: widget_metadata?.payload?.filter_by,
        filter_dropdown: widget_metadata?.payload?.filter_dropdown || [],
        filter_by_dropdown: widget_metadata?.payload?.filter_by_dropdown || [],
        screen: pathName === "CommandCenter"?.toLowerCase() ? screen : null,
        public_engagement_only: public_engagement_only ? true : false,
      };
      graphObject.isSectionCompetitorBrandTypeExists = (() => {
        // Return false if any of these conditions are true
        if (
          widget_metadata?.duplicate_for_brands ||
          (shareBrands &&
            widget_metadata?.is_locked &&
            widget_brands?.columns) ||
          (shareBrands &&
            section_metadata?.is_locked &&
            section_brands?.columns) ||
          (!shareBrands &&
            widgets_is_locked &&
            (widget_metadata?.brand_ids || widget_metadata?.brand_groups)) ||
          (!shareBrands &&
            Section_is_locked &&
            (section_metadata?.brand_ids || section_metadata?.brand_groups))
        ) {
          return false;
        }

        // Return true only if sectionCompetitorBrandTypeExists is true and globalBrandChangeInShare is true
        return (
          (sectionComprtitorBrandTypeExists && globalBrandChangeInShare) ||
          false
        );
      })();
      graphObject.isBrandModified =
        !shareBrands &&
        (global_brands ||
          (widgets_is_locked &&
            (widget_brands?.columns
              ? widget_brands?.columns?.length
              : widget_brands?.length)) ||
          (Section_is_locked &&
            (section_brands?.columns
              ? section_brands?.columns?.length
              : section_brands?.length)) ||
          widget_metadata?.duplicate_for_brands)
          ? true
          : false;

      dispatch(
        setIsDetailedInsightVisible({
          value: false,
          tab_id: null,
          name:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "Word Cloud"
              : "Mentions",
          key:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "2"
              : "1",
        })
      );

      dispatch(
        setTabClick({
          tabName:
            workspace_privileges?.environment === 2 ||
            share_workspace_privileges?.environment === 2
              ? "wordcloud"
              : "mentions",
          state: true,
        })
      );
      dispatch(setDeepDiveObject(graphObject));
      dispatch(setDeepDiveMentionsObject(graphObject));
      dispatch(setDeepDiveInfluencersObject(graphObject));
      shareTemplateData &&
        dispatch({
          type: "SET_SHARE_TEMPLATE_DATA",
          payload: {
            ...shareTemplateData,
            isDeepDive: true,
            deep_dive: {
              infoBar: null,
              mentions: null,
              wordcloud: [],
              category: [],
              top_users: [],
              influencers: [],
              source_of_post: [],
              locations: [],
            },
          },
        });

      let deep_dive_object = {
        infoBar: null,
        mentions: null,
        wordcloud: [],
        category: [],
        top_users: [],
        influencers: [],
        source_of_post: [],
        locations: [],
      };

      // Enable Deep Dive Modal
      dispatch(setScreenIsDeepDive(true, deep_dive_object));

      dispatch(set_WM_DeepDive(true));
      dispatch(setDeepDiveInfoLoader(true));
      // Get Deep Dive Api Call Function
      dispatch(
        getDeepDive(authParams, graphObject, widget_ids, query?.get("share_id"))
      );
    } else if (
      authParams?.screen_id === "000-000-551" &&
      data?.text === "Others" &&
      data?.value !== null &&
      data?.value > 0
    ) {
      callNotification("Deep dive is not allowed on Others channel", "info");
    } else if (
      authParams?.screen_id === "000-000-551" &&
      data?.text === "Multiple" &&
      data?.value !== null &&
      data?.value > 0
    ) {
      callNotification(
        "Deep dive is not allowed on Multiple sentiment",
        "info"
      );
    }
  };
  kpiData = kpiData?.[0]?.data ? kpiData?.[0]?.data : kpiData;
  return (
    <div className="row">
      {kpiData?.map((data) => {
        return (
          <>
            <div
              onClick={(e) => handleKpiDeepdive(e, data)}
              className="col"
              style={{ textAlign: "center", color: "#fff" }}
            >
              <Tooltip title={data?.text}>
                <Space wrap>
                  <Progress
                    className="cursor-pointer"
                    width={80}
                    trailColor="#243B65"
                    strokeColor={
                      data?.attribute?.toLowerCase() ===
                      "SentimentType"?.toLowerCase()
                        ? data?.color
                        : "#F0C52F"
                    }
                    strokeWidth={10}
                    type="circle"
                    percent={data?.share ? data?.share : 0}
                    format={() => (
                      <span>
                        {data?.attribute?.toLowerCase() ===
                        "SentimentType"?.toLowerCase() ? (
                          <span
                            style={{
                              color: "#E8EAEE",
                              textTransform: "uppercase",
                            }}
                          >
                            {data?.text}
                          </span>
                        ) : (
                          <img
                            style={{
                              width: "2.5rem",
                              height: "2.5rem",
                              margin: "0.5rem",
                            }}
                            src={
                              SocialMedialogo?.[data?.text?.trim()]
                                ? SocialMedialogo?.[data?.text?.trim()]
                                : defaultImage
                            }
                          />
                        )}
                      </span>
                    )}
                  />
                </Space>
              </Tooltip>
              <div style={{ marginTop: "0.5rem", fontWeight: "700" }}>
                {data?.attribute?.toLowerCase() ===
                  "SentimentType"?.toLowerCase() ||
                data?.attribute?.toLowerCase() ===
                  "SocialMediaPlatforms"?.toLowerCase() ? (
                  <div>
                    {data?.value ? data?.value?.toLocaleString() : 0}
                    <span className="updated-percentage-count">
                      {" "}
                      | {data?.share ? data?.share : 0}%
                    </span>
                  </div>
                ) : (
                  <div>{data?.value?.toLocaleString()}</div>
                )}
              </div>
            </div>
          </>
        );
      })}
    </div>
  );
};

export default CircularKpi;
